module.exports = __webpack_public_path__ + "static/media/privacy-policy-new.51833bd4.pdf";